import { Link } from 'react-router-dom'
import { ImageLogo, LogoContainer } from '../styled-components.js'
import logo from '@images/logo-white.svg'

export const LogoComponent = () => {
  return (
    <LogoContainer as={Link} to={'/'}>
      <ImageLogo src={logo} alt="logo" />
    </LogoContainer>
  )
}
